import React from "react";

const CLMNewsletter = ({config, cdnpath}) => {
    return (
        <div className="background-secondary">
            <div className="CLMNewsletter">
                <div id="NewsletterSignUp">
                    <div className="cover-img">
                        <img src={`${cdnpath}assets/${config.image.src}`} alt={config.image.alt} title={config.image.title} style={{width: "358px", height: "300px"}}/>
                    </div>
                    <div className="cover-text">
                        <div className="h1 text-white">{config.title}</div>
                        <p className="text-white">{config.summary}</p>
                        <button className="action-btn btn brandedButton inverted" onClick={() => {
                            window.open(config.button.url,'_blank');
                        }}>{config.button.text}</button>
                    </div>
                </div>
                {/* </ParallaxBanner> */}
            </div>
        </div>
    );
};

export default CLMNewsletter;
